export default __webpack_public_path__ + "static/media/hair-soft-summer.54bd0efd.png";